import React from 'react';
import { TRACT_LAYERS } from 'src/components/project/sections/GISComponents/MapConfig';

interface IGISPortalLayerSettingsProps {
    /** Layer key (tractLayersConfig key) -> shown on this project's map. */
    enabled: Record<string, boolean>;
    onChange: (key: string, enabled: boolean) => void;
    disabled: boolean;
    /** Why the checkboxes can't be changed right now, shown under them. */
    note?: string;
}

/*
 * Map Layers: which tract layers this project's map shows. Saved into the project's config.json with
 * the rest of the form; the map leaves out any layer turned off here.
 */
const GISPortalLayerSettings: React.FC<IGISPortalLayerSettingsProps> = ({ enabled, onChange, disabled, note }) => (
    <>
        <br />
        <hr />
        <h4>Map Layers</h4>
        <p style={{ margin: '0 0 0.5rem' }}>
            Tract layers shown on this project&apos;s map. A contract layer appears only once the project has contracts of that type.
        </p>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(12rem, 1fr))', gap: '0.25rem 1rem' }}>
            {TRACT_LAYERS.map(({ key, label }) => (
                <label key={key} style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', margin: 0, fontWeight: 'normal' }}>
                    <input type="checkbox" checked={enabled[key] !== false} disabled={disabled} onChange={(e) => onChange(key, e.target.checked)} />
                    {label}
                </label>
            ))}
        </div>
        {note && <p style={{ margin: '0.5rem 0 0', color: '#a33' }}>{note}</p>}
    </>
);

export default GISPortalLayerSettings;



// WEBPACK FOOTER //
// ./src/components/gis/portal/GISPortalLayerSettings.tsx